/* eslint-disable arrow-body-style */
import { PC_CONSOLE_COMBINE_ENTITY_TYPE } from '@intelligence/pages/TopCharts/_config/topChartsConst';

export const ENTITY_TYPE_NAMES_MAP: {
  [key: string]: string;
} = {
  mobile: 'dbi_mobile',
  [PC_CONSOLE_COMBINE_ENTITY_TYPE]: 'dbi_pc_console_combine',
};
